module.exports = __webpack_public_path__ + "img/home_en_primeur.d19a938.png";